export enum PointerType {
  TOUCH,
  STYLUS,
  MOUSE,
  OTHER,
}
